import { render, staticRenderFns } from "./WireframeTab.vue?vue&type=template&id=3a3ec301"
import script from "./WireframeTab.vue?vue&type=script&lang=js"
export * from "./WireframeTab.vue?vue&type=script&lang=js"
import style0 from "./WireframeTab.vue?vue&type=style&index=0&id=3a3ec301&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports